/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import AWS from 'aws-sdk';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GridLayout from 'react-grid-layout';
import moment from 'utils/moment';
import styles from './home.module.scss';
import Weather from './weather/Weather';
import Advisories from './advisories/Advisories';
import { saveWeatherData } from '../../general_redux/actions';
import { fetchUserProfile } from '../../components/topbar/profile/redux/actions';
import { fetchPortalTilesList, clear, fetchPortalTilesAlingment, fetchSurfaces } from './redux/actions';
import Loading from '../../components/loading';
import Report from './report/Report';
import Feed from './socialFeed/Feed';
import Events from './events/Events';
import PortalTile from './portalTile/PortalTile';
import Alert from './alert/Alert';
import ReportHazard from './reportHazard/ReportHazard';
import MaintenanceResponsibility from './MaintenanceResponsibility';
import DocumentList from '../Documents/DocumentList';
import { fetchDocuments, fetchDocumentsTypes } from '../Documents/redux/actions';
import SnowMaps from './portalTile/SnowMaps';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tilesVisibilityStatus: {},
      newTiles: [],
      loadingStatus: false,
      events: [],
      initialRender: true,
      new_attachment_tiles: [],
      documentsList: [],
      defaultLayout: [
        { h: 8, i: 'a', w: 3, x: 0, y: 0 },
        { h: 2, i: 'b', w: 3, x: 0, y: 8 },
        { h: 4, i: 'c', w: 4, x: 8, y: 14 },
        { h: 10, i: 'd', w: 5, x: 3, y: 0 },
        { h: 2, i: 'e', w: 4, x: 8, y: 0 },
        { h: 8, i: 'f', w: 4, x: 8, y: 2, maxH: 8, maxW: 4, minH: 8, minW: 4 },
        { h: 4, i: 'g', w: 4, x: 8, y: 10 }
      ],
      init: true,
      snowManagement: false
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!Object.keys(state.tilesVisibilityStatus).length && props.portalTiles) {
      const newTiles = props.portalTiles.filter(tile => tile.system_generated === false && tile.visibility === true);
      const status = props.portalTiles.reduce(
        (obj, tile) => Object.assign(obj, { [tile.tile_name]: tile.visibility }), {}
      );

      return {
        ...state,
        tilesVisibilityStatus: status,
        newTiles
      };
    }
    if (state.newTiles.length > 0 && !state.events.length > 0 && state.initialRender) {
      const upcoming_events = [];
      const new_attachment_tiles = [];
      state.newTiles.forEach((tile) => {
        const obj = {};
        const events_happening = [];
        if (tile.events.length > 0) {
          tile.events.forEach((event) => {
            const currentDate = Date.now();
            const yesterday = moment(currentDate).add(-1, 'days').format('Y/M/D');
            const eventDate = moment(event.date).format('Y/M/D');
            if (moment(eventDate).isAfter(yesterday)) {
              events_happening.push(event);
            }
          });
          events_happening.sort((a, b) => new Date(a.date) - new Date(b.date));
          if (events_happening.length > 0) {
            obj.tile_name = tile.tile_name;
            obj.id = tile.id;
            obj.subscribed = tile.subscribed;
            obj.events = events_happening;
            obj.events_len = events_happening.length;
            upcoming_events.push(obj);
          }
        }
        if (tile.events.length === 0) {
          if (tile.attachment.length > 0 && tile.attachment[0].url) {
            new_attachment_tiles.push(tile);
          }
        }
      });
      return {
        ...state,
        initialRender: false,
        events: upcoming_events,
        new_attachment_tiles
      };
    }
    if (state.documentsList?.length !== props?.documentList?.documents?.length) {
      const filterRequired = props?.documentList?.documents;
      const filterRequiredDocs = filterRequired?.filter((doc) => {
        const hasDocumentType = !!doc?.document_type;
        const hasAttachments = doc?.attachments?.length > 0;
        const isValidDate = doc.valid_date && new Date(doc.valid_date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
        const hasStatus = doc?.status === 'reject';
        return !hasDocumentType || !hasAttachments || !isValidDate || hasStatus;
      }) || [];
      return {
        ...state,
        documentsList: filterRequiredDocs
      };
    }
    return {};
  }

  async componentDidMount() {
    const {
      actionFetchPortalTiles,
      actionFetchProfile,
      actionFetchPortalTilesAlingment,
      actionFetchDocuments,
      actionFetchDocumentsTypes
    } = this.props;
    actionFetchDocuments();
    actionFetchDocumentsTypes();
    actionFetchPortalTilesAlingment();
    // Initialize the Amazon Cognito credentials provider
    const gp = this.getAWSCredentails();
    gp.then(() => {
      this.setState({ loadingStatus: true });
      actionFetchPortalTiles();
      actionFetchProfile();
    }).catch((err) => {
      console.log(err);
    });
  }

  componentDidUpdate(prevProps) {
    const {
    portalTiles,
    actionFetchMaps,
    actionClear,
    fetchPortalTileAction,
    layout
  } = this.props;
  const { init } = this.state;
    if (prevProps.portalTiles !== portalTiles) {
    const snowTile = portalTiles?.find(
      t => t.tile_name === 'Snow Priority Zones' && t.visibility === true
    );

    if (snowTile) {
      actionFetchMaps();
    }
  }
    if (prevProps.fetchPortalTileAction.loading === true && fetchPortalTileAction.loading === false) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loadingStatus: false }, () => {
        actionClear();
      });
    }
    if (prevProps.layout !== layout && init) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ defaultLayout: layout, init: false });
    }
  }

  getAWSCredentails = () => {
    AWS.config.region = process.env.REACT_APP_REGION;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  }

  updateDocuments = () => {
    const {
      actionFetchDocuments,
      actionFetchDocumentsTypes
    } = this.props;
    actionFetchDocuments();
    actionFetchDocumentsTypes();
  }

  render() {
    const { profile, layout, history, mapSurfaces, portalTiles } = this.props;
    const { tilesVisibilityStatus, events, loadingStatus, defaultLayout } = this.state;
    if (Object.keys(profile?.permissions).length===1 && Object.keys(profile?.permissions)[0] === 'airfield_worker_driver_permit') {
      history.push('/adp/myapplications');
    }
    const renderTile = (key, condition, style = {}, datagrid, children) => {
      if (!condition) return null; // Return null if the condition is not met
      return (
        <div key={key} style={style} data-grid={defaultLayout?.find(i => i?.i === key) || datagrid}>
          {children}
        </div>
      );
    };
    const { documentsList, new_attachment_tiles } = this.state;
    const { documentTypes, leaseDocumentPermission, avpModulePermission } = this.props;
    const snowTile = portalTiles?.find(
  t => t.tile_name === 'Snow Priority Zones' && t.visibility
);
    return (
      <div className={styles.home}>
        <Loading loadingStatus={loadingStatus} />
          {documentsList?.length > 0 && (leaseDocumentPermission || avpModulePermission) && (
            <div className={styles.documentsTile}>
              <DocumentList
                homeTabTile
                documentsList={documentsList}
                document_types={documentTypes?.document_types || []}
                updateDocuments={this.updateDocuments}
              />
            </div>
          )}
          {profile?.maintenance_responsibility_enabled
          && <div style={profile?.current_tenant?.maintenance_responsibility
          ? { height: '250px', width: '1400px', padding: '0 10px' } : { display: 'none' }}>
          <MaintenanceResponsibility maintenance_responsibility={profile?.current_tenant?.maintenance_responsibility} />
             </div>
          }
          <GridLayout
          layout={defaultLayout}
          cols={12}
          rowHeight={90}
          width={1400}
          allowOverlap={false}
          isResizable={false}
          isDraggable={false}
        >
          {/* Weather Tile */}
          {renderTile(
            'a',
            tilesVisibilityStatus?.Weather,
            { border: 'solid 1px #E6EAEE', borderRadius: '5px' },
            { h: 8, i: 'a', w: 3, x: 0, y: 0 },
            <Weather />
          )}

          {/* Report Hazard Tile */}
          {renderTile(
            'b',
            tilesVisibilityStatus?.['Report Hazard'],
            {},
            { h: 2, i: 'b', w: 3, x: 0, y: 8 },
            <div className={styles.reportFeedContainer}>
              <ReportHazard airport={profile.portal_airport} />
            </div>
          )}

          {/* Alerts Tile */}
          {renderTile(
            'c',
            tilesVisibilityStatus?.Alerts,
            {},
            { h: 4, i: 'c', w: 4, x: 8, y: 14 },
            <Alert />
          )}

          {/* Tenant Advisories Tile */}
          {renderTile(
            'd',
            tilesVisibilityStatus?.['Tenant Advisories'],
            {},
            { h: 10, i: 'd', w: 5, x: 3, y: 0 },
            <Advisories airport={profile.portal_airport} />
          )}

          {/* Airfield Conditions Report Tile */}
          {renderTile(
            'e',
            tilesVisibilityStatus?.['Airfield Conditions Report'],
            {},
            { h: 2, i: 'e', w: 4, x: 8, y: 0 },
            <div className={styles.reportFeedContainer}>
              <Report airport={profile.portal_airport} />
            </div>
          )}

          {/* Social Media Tile */}
          {renderTile(
            'f',
            tilesVisibilityStatus?.['Social Media'] && profile.urls,
            {},
            { h: 8, i: 'f', w: 4, x: 8, y: 2 },
            <Feed links={profile.urls} />
          )}

          {/* New Attachment Tiles */}
          {new_attachment_tiles?.map((tile, i) => {
            const L = layout?.find(t => t?.i === `${i}`) || { w: 8, h: 4, x: 0, y: 10 };
            return (
              <div key={tile.tile_name} data-grid={L}>
                <PortalTile data={tile} />
              </div>
            );
          })}

          {renderTile(
            'snow',
            mapSurfaces?.length > 0 && snowTile,
            {},
            { h: 6, i: 'snow', w: 4, x: 4, y: 20 },
            <div className={styles.tileContainer}>
              <div className={styles.tileHeader}>{snowTile?.tile_name}</div>
              <SnowMaps surfaces={mapSurfaces} />
            </div>
          )}


          {/* Events Tile */}
          {renderTile(
            'g',
            events?.length,
            { overflow: 'auto' },
            { h: 4, i: 'g', w: 4, x: 8, y: 10 },
            <Events data={events} />
          )}
          </GridLayout>
      </div>
    );
  }
}

Home.propTypes = {
  intl: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  currentModule: state.general.currentModule,
  weatherData: state.general.weather,
  documentList: state.document.documentList,
  leaseDocumentPermission: state.auth?.leaseDocumentPermission,
  avpModulePermission: state.auth?.avpModulePermission,
  profile: state.auth.profile,
  portalTiles: state.home.portalTilesList,
  fetchPortalTileAction: state.home.fetchPortalTileAction,
  layout: state.home.portalTilesAlingment?.portal_tiles_alignment?.map(tile => ({ ...tile, isResizable: false, isDraggable: false })),
  documentTypes: state.document.documentTypes,
  mapSurfaces: state.home?.surfaces
});

const mapDispatchToProps = dispatch => ({
  actionSaveWeatherData: (weather) => {
    dispatch(saveWeatherData(weather));
  },
  actionFetchDocuments: () => {
    dispatch(fetchDocuments());
  },
  actionFetchDocumentsTypes: () => {
    dispatch(fetchDocumentsTypes());
  },
  actionFetchProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionFetchPortalTiles: () => {
    dispatch(fetchPortalTilesList());
  },
  actionClear: () => {
    dispatch(clear());
  },
  actionFetchPortalTilesAlingment: () => {
    dispatch(fetchPortalTilesAlingment());
  },
  actionFetchMaps: () => {
    dispatch(fetchSurfaces());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Home));
